export enum IncomingBankPaymentStatusEnum {
  Matched = 2,
  UnMatched = 1,
}
